<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 160px;border-radius:5px;padding:5px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de solicitudes de codigo
    v-dialog(v-model='dialog6', persistent max-width='1000px')
      v-card
        v-card-text
          v-container(id="printJS-form2")
            div(align='left')
              img(src='../assets/logo.png', style='width: 200px;margin-top: -20px;margin-bottom: -25px;margin-left: -28px;')
              h5(style='font-weight: 700 !important;') FICHA DEL CLIENTE
            div(style='display: flex;justify-content: flex-end;')
              table(align="center" style='width: 480px;border-collapse: collapse;')
                tr
                  td.withTd2(align='right' style="padding: 0px 10px 0px 10px;width: 240px;")
                    b(style='font-weight: 700;') NOMBRE DEL VENDEDOR
                  td.withTd2(align='left' style="padding: 0px 10px 0px 10px;")
                    b(v-if="form.ven_des" style='font-weight: 400;') {{form.ven_des}}
                    b(v-else style='font-weight: 400;') N/A
                tr
                  td.withTd2(align='right' style="padding: 0px 10px 0px 10px;width: 240px;")
                    b(style='font-weight: 700;') ZONA
                  td.withTd2(align='left' style="padding: 0px 10px 0px 10px;")
                    b(v-if="form.zona" style='font-weight: 400;') {{form.zona}}
                    b(v-else style='font-weight: 400;') N/A
            table(align="center" style='width: 100%;border-collapse: collapse;margin-top:20px;background: #cde2f4;')
              tr
                td.withTd2(align='center' style="padding: 0px 10px 0px 10px;border-bottom: 0px;")
                  b(style='font-weight: 700;') Datos del cliente
            table(align="center" style='width: 100%;border-collapse: collapse;')
              tr
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;width: 200px;")
                  b(style='font-weight: 700;') Rif del cliente
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;width:270px;")
                  b(v-if="form.rif" style='font-weight: 400;') {{form.rif}}
                  b(v-else style='font-weight: 400;') N/A
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;width: 160px;")
                  b(style='font-weight: 700;') Razón social
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;")
                  b(v-if="form.razon" style='font-weight: 400;') {{form.razon}}
                  b(v-else style='font-weight: 400;') N/A
            table(align="center" style='width: 100%;border-collapse: collapse;')
              tr
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 200px;")
                  b(style='font-weight: 700;') Dirección fiscal
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;;border-top: 0px;")
                  b(v-if="form.direccionFiscal" style='font-weight: 400;') {{form.direccionFiscal}}
                  b(v-else style='font-weight: 400;') N/A
            table(align="center" style='width: 100%;border-collapse: collapse;')
              tr
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 200px;")
                  b(style='font-weight: 700;') Dirección de entrega
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;;border-top: 0px;")
                  b(v-if="form.direccionEntrega" style='font-weight: 400;') {{form.direccionEntrega}}
                  b(v-else style='font-weight: 400;') N/A
            table(align="center" style='width: 100%;border-collapse: collapse;')
              tr
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 200px;")
                  b(style='font-weight: 700;') Punto de referencia
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;;border-top: 0px;")
                  b(v-if="form.puntoRef" style='font-weight: 400;') {{form.puntoRef}}
                  b(v-else style='font-weight: 400;') N/A
            table(align="center" style='width: 100%;border-collapse: collapse;')
              tr
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 200px;")
                  b(style='font-weight: 700;') Ciudad
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width:270px; ")
                  b(v-if="form.ciudad" style='font-weight: 400;') {{form.ciudad}}
                  b(v-else style='font-weight: 400;') N/A
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 160px;")
                  b(style='font-weight: 700;') Estado
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;")
                  b(v-if="form.estado" style='font-weight: 400;') {{form.estado}}
                  b(v-else style='font-weight: 400;') N/A
              tr
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 200px;")
                  b(style='font-weight: 700;') Teléfono local
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width:270px; ")
                  b(v-if="form.telefonoLocal" style='font-weight: 400;') {{form.telefonoLocal}}
                  b(v-else style='font-weight: 400;') N/A
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 160px;")
                  b(style='font-weight: 700;') Teléfono celular
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;")
                  b(v-if="form.telefonoMovil" style='font-weight: 400;') {{form.telefonoMovil}}
                  b(v-else style='font-weight: 400;') N/A
              tr
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 200px;")
                  b(style='font-weight: 700;') Contribuyente especial
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width:270px; ")
                  b(v-if="form.contribEsp" style='font-weight: 400;') {{form.contribEsp}}
                  b(v-else style='font-weight: 400;') N/A
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 160px;")
                  b(style='font-weight: 700;') P. de contacto
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;")
                  b(v-if="form.personaCont" style='font-weight: 400;') {{form.personaCont}}
                  b(v-else style='font-weight: 400;') N/A
              tr
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 200px;")
                  b(style='font-weight: 700;') Instagram
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width:270px; ")
                  b(v-if="form.instagram" style='font-weight: 400;') {{form.instagram}}
                  b(v-else style='font-weight: 400;') N/A
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 160px;")
                  b(style='font-weight: 700;') Facebook
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;")
                  b(v-if="form.facebook" style='font-weight: 400;') {{form.facebook}}
                  b(v-else style='font-weight: 400;') N/A
              tr
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 200px;")
                  b(style='font-weight: 700;') Local Comercial
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width:270px; ")
                  b(v-if="form.tipoLocal" style='font-weight: 400;') {{form.tipoLocal}}
                  b(v-else style='font-weight: 400;') N/A
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 160px;")
                  b(style='font-weight: 700;') Grupo o sucursal
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;")
                  b(v-if="form.sucursal" style='font-weight: 400;') {{form.sucursal}}
                  b(v-else style='font-weight: 400;') N/A
            table(align="center" style='width: 100%;border-collapse: collapse;')
              tr
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 200px;")
                  b(style='font-weight: 700;') Límite de crédito
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;;border-top: 0px;")
                  b(v-if="form.limiteCred" style='font-weight: 400;') {{form.limiteCred}}$
                  b(v-else style='font-weight: 400;') N/A
            table(align="center" style='width: 100%;border-collapse: collapse;background: #cde2f4;')
              tr
                td.withTd2(align='center' style="padding: 0px 10px 0px 10px;border-top: 0px;")
                  b(style='font-weight: 700;') Clase/ Segmento
            div(class="tablaD")
              div(style="width: 48%;")
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Distribuidor
                  b(v-if='form.segmento == "Distribuidor"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Supermercado
                  b(v-if='form.segmento == "Supermercado"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Hipermercados
                  b(v-if='form.segmento == "Hipermercado"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Salón
                  b(v-if='form.segmento == "Salón"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Tienda online
                  b(v-if='form.segmento == "Tienda online"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
              div(style="width: 48%;padding-right: 20px;")
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Perfumería
                  b(v-if='form.segmento == "Perfumeria"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Cadena de perfumería
                  b(v-if='form.segmento == "Cadena de perfumeria"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Farmacia
                  b(v-if='form.segmento == "Farmacias"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Mayoristas
                  b(v-if='form.segmento == "Mayoristas"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Tienda de electrónica
                  b(v-if='form.segmento == "Tienda de electronica"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
            table(align="center" style='width: 100%;border-collapse: collapse;background: #cde2f4;margin-top:20px')
              tr
                td.withTd2(align='center' style="padding: 0px 10px 0px 10px;")
                  b(style='font-weight: 700;') Tipo de Cliente para Asignar el Descuento (Lista de Precio)
            div(class="tablaD")
              div(style="width: 50%;")
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Distribuidor
                  b(v-if='form.tipoCli == "Distribuidor"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Punto de venta
                  b(v-if='form.tipoCli == "Punto de venta"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Salones de belleza
                  b(v-if='form.tipoCli == "Salones de belleza"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Barberias
                  b(v-if='form.tipoCli == "Barberias"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
                div(class="tablaI")
                  b(style='font-weight: 700;width:240px;') Consumidor final
                  b(v-if='form.tipoCli == "Consumidor final"' style='font-weight: 700;') ______X______
                  b(v-else style='font-weight: 700;') _____________
            table(align="center" style='width: 100%;border-collapse: collapse;background: #cde2f4;')
              tr
                td.withTd2(align='center' style="padding: 0px 10px 0px 10px;border-top: 0px;")
                  b(style='font-weight: 700;') Referencias comerciales
            table(align="center" style='width: 100%;border-collapse: collapse;')
              tr
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 280px;")
                  b(style='font-weight: 700;') Empresa
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 150px; ")
                  b(style='font-weight: 700;') Rif o Cedula
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 150px;")
                  b(style='font-weight: 700;') Teléfono
              tr(v-if='form.referenciasComer && form.referenciasComer[0] && form.referenciasComer[0].empresa')
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 280px;")
                  b(style='font-weight: 500;') {{form.referenciasComer[0].empresa}}
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 150px; ")
                  b(style='font-weight: 500;') {{form.referenciasComer[0].rif}}
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 150px;")
                  b(style='font-weight: 500;') {{form.referenciasComer[0].telefono}}
              tr(v-if='form.referenciasComer && form.referenciasComer[1] && form.referenciasComer[1].empresa')
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 280px;")
                  b(style='font-weight: 500;') {{form.referenciasComer[1].empresa}}
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 150px; ")
                  b(style='font-weight: 500;') {{form.referenciasComer[1].rif}}
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 150px;")
                  b(style='font-weight: 500;') {{form.referenciasComer[1].telefono}}
              tr(v-if='form.referenciasComer && form.referenciasComer[2] && form.referenciasComer[2].empresa')
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 280px;")
                  b(style='font-weight: 500;') {{form.referenciasComer[2].empresa}}
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 150px; ")
                  b(style='font-weight: 500;') {{form.referenciasComer[2].rif}}
                td.withTd2(align='left' style="padding: 0px 10px 0px 10px;border-top: 0px;width: 150px;")
                  b(style='font-weight: 500;') {{form.referenciasComer[2].telefono}}
            div(class="divFirma")
              div(style="width:50%;")
                b(style='font-weight: 700;') Firma del vendedor
                div(style='display: flex;flex-direction: column;color: #898f97;')
                  span(style="font-size:10px;font-weight: 700;text-decoration: underline;padding-bottom:2px") Recaudos: 
                  span(style="font-size:10px;font-weight: 500;") Copia Rif o Cedula
                  span(style="font-size:10px;font-weight: 500;") Copia registro mercantil
                  span(style="font-size:10px;font-weight: 500;") 3 referencias comerciales (copia factura)
                  span(style="font-size:10px;font-weight: 500;") 2 fotos de local comercial (fachada y piso de venta)
                  span(style="font-size:10px;font-weight: 500;") Carta de  notificación de contribuyente especial (seniat)
              div(style="width:50%;text-align: right;")
                b(style='font-weight: 700;') Firma y Sello del cliente
        v-card-actions
          v-spacer
          v-btn(color='error' small dark @click='close4()')
            v-icon mdi-close
            | Cancelar
          v-btn(color='success' small dark @click="imprimirPdf2()")
            v-icon mdi-content-save
            | PDF  
    v-dialog(v-model='dialog', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Solicitud
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")

                            v-text-field(outline
                            readonly
                            v-model="form.razon"
                            prepend-inner-icon="description"
                            label="Razon social:")

                            v-text-field(outline
                            readonly
                            v-model="form.rif"
                            prepend-inner-icon="description"
                            label="Rif:")

                            v-text-field(outline
                            readonly
                            v-model="form.contribEsp"
                            prepend-inner-icon="description"
                            label="Tipo de contribuyente:")

                            v-text-field(outline
                            readonly
                            v-model="form.tipoLocal"
                            prepend-inner-icon="description"
                            label="Tipo de local:")

                            v-text-field(outline
                            readonly
                            v-model="form.sucursal"
                            prepend-inner-icon="description"
                            label="Grupo o sucursal:")

                            v-text-field(outline
                            readonly
                            v-model="form.limiteCred"
                            prepend-inner-icon="description"
                            label="Limite de crédito:")

                            v-text-field(outline
                            readonly
                            v-model="form.segmento"
                            prepend-inner-icon="description"
                            label="Clase/Segmento:")

                            v-text-field(outline
                            readonly
                            v-model="form.tipoCli"
                            prepend-inner-icon="description"
                            label="Tipo de cliente:")

                            v-text-field(outline
                            readonly
                            v-model="form.ciudad"
                            prepend-inner-icon="description"
                            label="Ciudad:")

                            v-text-field(outline
                            readonly
                            v-model="form.estado"
                            prepend-inner-icon="description"
                            label="Estado:")

                            v-text-field(outline
                            readonly
                            v-model="form.direccionFiscal"
                            prepend-inner-icon="description"
                            label="Dirección fiscal:")

                            v-text-field(outline
                            readonly
                            v-model="form.direccionEntrega"
                            prepend-inner-icon="description"
                            label="Dirección de entrega:")

                            v-text-field(outline
                            readonly
                            v-model="form.telefonoLocal"
                            prepend-inner-icon="description"
                            label="Teléfono local:")

                            v-text-field(outline
                            readonly
                            v-model="form.telefonoMovil"
                            prepend-inner-icon="description"
                            label="Teléfono móvil:")

                            v-text-field(outline
                            readonly
                            v-model="form.email"
                            prepend-inner-icon="description"
                            label="E-mail:")

                            v-text-field(outline
                            readonly
                            v-model="form.instagram"
                            prepend-inner-icon="description"
                            label="Instagram:")

                            v-text-field(outline
                            readonly
                            v-model="form.facebook"
                            prepend-inner-icon="description"
                            label="Facebook:")

                            v-card(style="margin-right: 0px;margin-top: 10px;margin-bottom: 35px;")
                              v-card-title.justify-center
                                span REPRESENTANTES DE LA COMPAÑIA

                            v-text-field(outline
                            readonly
                            v-if='form.representCompania && form.representCompania[0]'
                            v-model="form.representCompania[0].representante"
                            prepend-inner-icon="description"
                            label="Representante:")

                            v-text-field(outline
                            readonly
                            v-if='form.representCompania && form.representCompania[0]'
                            v-model="form.representCompania[0].cedula"
                            prepend-inner-icon="description"
                            label="Cédula:")

                            v-text-field(outline
                            readonly
                            v-if='form.representCompania && form.representCompania[0]'
                            v-model="form.representCompania[0].cargo"
                            prepend-inner-icon="description"
                            label="Cargo:")

                            v-text-field(outline
                            readonly
                            v-if='form.representCompania && form.representCompania[0]'
                            v-model="form.representCompania[0].telefono"
                            prepend-inner-icon="description"
                            label="Teléfono:")

                            div(style='background:grey;height: 2px;width:100%;margin-top:10px;margin-bottom:35px;')

                            v-text-field(outline
                            readonly
                            v-if='form.representCompania && form.representCompania[1]'
                            v-model="form.representCompania[1].representante"
                            prepend-inner-icon="description"
                            label="Representante:")

                            v-text-field(outline
                            readonly
                            v-if='form.representCompania && form.representCompania[1]'
                            v-model="form.representCompania[1].cedula"
                            prepend-inner-icon="description"
                            label="Cédula:")

                            v-text-field(outline
                            readonly
                            v-if='form.representCompania && form.representCompania[1]'
                            v-model="form.representCompania[1].cargo"
                            prepend-inner-icon="description"
                            label="Cargo:")

                            v-text-field(outline
                            readonly
                            v-if='form.representCompania && form.representCompania[1]'
                            v-model="form.representCompania[1].telefono"
                            prepend-inner-icon="description"
                            label="Teléfono:")

                            div(style='background:grey;height: 2px;width:100%;margin-top:10px;margin-bottom:35px;')

                            v-text-field(outline
                            readonly
                            v-if='form.representCompania && form.representCompania[2]'
                            v-model="form.representCompania[2].representante"
                            prepend-inner-icon="description"
                            label="Representante:")

                            v-text-field(outline
                            readonly
                            v-if='form.representCompania && form.representCompania[2]'
                            v-model="form.representCompania[2].cedula"
                            prepend-inner-icon="description"
                            label="Cédula:")

                            v-text-field(outline
                            readonly
                            v-if='form.representCompania && form.representCompania[2]'
                            v-model="form.representCompania[2].cargo"
                            prepend-inner-icon="description"
                            label="Cargo:")

                            v-text-field(outline
                            readonly
                            v-if='form.representCompania && form.representCompania[2]'
                            v-model="form.representCompania[2].telefono"
                            prepend-inner-icon="description"
                            label="Teléfono:")

                            div(style='background:grey;height: 2px;width:100%;margin-top:10px;margin-bottom:35px;')

                            v-card(style="margin-right: 0px;margin-top: 10px;margin-bottom: 35px;")
                              v-card-title.justify-center
                                span REFERENCIAS COMERCIALES

                            v-text-field(outline
                            readonly
                            v-if='form.referenciasComer && form.referenciasComer[0]'
                            v-model="form.referenciasComer[0].empresa"
                            prepend-inner-icon="description"
                            label="Empresa:")

                            v-text-field(outline
                            readonly
                            v-if='form.referenciasComer && form.referenciasComer[0]'
                            v-model="form.referenciasComer[0].direccion"
                            prepend-inner-icon="description"
                            label="Dirección:")

                            v-text-field(outline
                            readonly
                            v-if='form.referenciasComer && form.referenciasComer[0]'
                            v-model="form.referenciasComer[0].telefono"
                            prepend-inner-icon="description"
                            label="Teléfono:")

                            v-text-field(outline
                            readonly
                            v-if='form.referenciasComer && form.referenciasComer[0]'
                            v-model="form.referenciasComer[0].rif"
                            prepend-inner-icon="description"
                            label="Rif:")

                            a(v-if='form.referenciasComer && form.referenciasComer[0] && form.referenciasComer[0].referencia' :href='ruta + form.referenciasComer[0].referencia' target='_blank' style='display:flex;justify-content:center;')
                              img(
                                v-if='!verificarPdf(form.referenciasComer[0].referencia)'
                                :src='ruta + form.referenciasComer[0].referencia'
                                style='width: 100%;height:auto;object-fit: contain;'
                              )
                              img(
                                v-if='verificarPdf(form.referenciasComer[0].referencia)'
                                src='../assets/pdf.svg'
                                style='width: 100px;height:auto;object-fit: contain;'
                              )

                            div(style='background:grey;height: 2px;width:100%;margin-top:10px;margin-bottom:35px;')

                            v-text-field(outline
                            readonly
                            v-if='form.referenciasComer && form.referenciasComer[1]'
                            v-model="form.referenciasComer[1].empresa"
                            prepend-inner-icon="description"
                            label="Empresa:")

                            v-text-field(outline
                            readonly
                            v-if='form.referenciasComer && form.referenciasComer[1]'
                            v-model="form.referenciasComer[1].direccion"
                            prepend-inner-icon="description"
                            label="Dirección:")

                            v-text-field(outline
                            readonly
                            v-if='form.referenciasComer && form.referenciasComer[1]'
                            v-model="form.referenciasComer[1].telefono"
                            prepend-inner-icon="description"
                            label="Teléfono:")

                            v-text-field(outline
                            readonly
                            v-if='form.referenciasComer && form.referenciasComer[1]'
                            v-model="form.referenciasComer[1].rif"
                            prepend-inner-icon="description"
                            label="Rif:")

                            a(v-if='form.referenciasComer && form.referenciasComer[1] && form.referenciasComer[1].referencia' :href='ruta + form.referenciasComer[1].referencia' target='_blank' style='display:flex;justify-content:center;')
                              img(
                                v-if='!verificarPdf(form.referenciasComer[1].referencia)'
                                :src='ruta + form.referenciasComer[1].referencia'
                                style='width: 100%;height:auto;object-fit: contain;'
                              )
                              img(
                                v-if='verificarPdf(form.referenciasComer[1].referencia)'
                                src='../assets/pdf.svg'
                                style='width: 100px;height:auto;object-fit: contain;'
                              )


                            div(style='background:grey;height: 2px;width:100%;margin-top:10px;margin-bottom:35px;')

                            v-text-field(outline
                            readonly
                            v-if='form.referenciasComer && form.referenciasComer[2]'
                            v-model="form.referenciasComer[2].empresa"
                            prepend-inner-icon="description"
                            label="Empresa:")

                            v-text-field(outline
                            readonly
                            v-if='form.referenciasComer && form.referenciasComer[2]'
                            v-model="form.referenciasComer[2].direccion"
                            prepend-inner-icon="description"
                            label="Dirección:")

                            v-text-field(outline
                            readonly
                            v-if='form.referenciasComer && form.referenciasComer[2]'
                            v-model="form.referenciasComer[2].telefono"
                            prepend-inner-icon="description"
                            label="Teléfono:")

                            v-text-field(outline
                            readonly
                            v-if='form.referenciasComer && form.referenciasComer[2]'
                            v-model="form.referenciasComer[2].rif"
                            prepend-inner-icon="description"
                            label="Rif:")

                            a(v-if='form.referenciasComer && form.referenciasComer[2] && form.referenciasComer[2].referencia' :href='ruta + form.referenciasComer[2].referencia' target='_blank' style='display:flex;justify-content:center;')
                              img(
                                v-if='!verificarPdf(form.referenciasComer[2].referencia)'
                                :src='ruta + form.referenciasComer[2].referencia'
                                style='width: 100%;height:auto;object-fit: contain;'
                              )
                              img(
                                v-if='verificarPdf(form.referenciasComer[2].referencia)'
                                src='../assets/pdf.svg'
                                style='width: 100px;height:auto;object-fit: contain;'
                              )

                            v-card(style="margin-right: 0px;margin-top: 10px;margin-bottom: 35px;")
                              v-card-title.justify-center
                                span USO INTERNO

                            v-text-field(outline
                            readonly
                            v-model="form.codigoFercove"
                            prepend-inner-icon="description"
                            label="Código Milo:")

                            v-text-field(outline
                            readonly
                            v-model="form.asesorVenta"
                            prepend-inner-icon="description"
                            label="Asesor de venta:")

                            v-card(v-if='form.imgRegistroM' style="margin-right: 0px;margin-top: 10px;margin-bottom: 35px;")
                              v-card-title.justify-center
                                span REGISTRO MERCANTIL

                            a(v-if='form.imgRegistroM' :href='ruta + form.imgRegistroM' target='_blank' style='display:flex;justify-content:center;')
                              img(
                                v-if='!verificarPdf(form.imgRegistroM)'
                                :src='ruta + form.imgRegistroM'
                                style='width: 100%;height:auto;object-fit: contain;'
                              )
                              img(
                                v-if='verificarPdf(form.imgRegistroM)'
                                src='../assets/pdf.svg'
                                style='width: 100px;height:auto;object-fit: contain;'
                              )

                            v-card(v-if='form.imgRifEmp' style="margin-right: 0px;margin-top: 10px;margin-bottom: 35px;")
                              v-card-title.justify-center
                                span RIF DE LA EMPRESA

                            a(v-if='form.imgRifEmp' :href='ruta + form.imgRifEmp' target='_blank' style='display:flex;justify-content:center;')
                                img(
                                  v-if='!verificarPdf(form.imgRifEmp)'
                                  :src='ruta + form.imgRifEmp'
                                  style='width: 100%;height:auto;object-fit: contain;'
                                )
                                img(
                                  v-if='verificarPdf(form.imgRifEmp)'
                                  src='../assets/pdf.svg'
                                  style='width: 100px;height:auto;object-fit: contain;'
                                )

                            v-card(v-if='form.imgRifRepreL' style="margin-right: 0px;margin-top: 10px;margin-bottom: 35px;")
                              v-card-title.justify-center
                                span RIF DEL REPRESENTANTE LEGAL

                            a(v-if='form.imgRifRepreL' :href='ruta + form.imgRifRepreL' target='_blank' style='display:flex;justify-content:center;')
                                img(
                                  v-if='!verificarPdf(form.imgRifRepreL)'
                                  :src='ruta + form.imgRifRepreL'
                                  style='width: 100%;height:auto;object-fit: contain;'
                                )
                                img(
                                  v-if='verificarPdf(form.imgRifRepreL)'
                                  src='../assets/pdf.svg'
                                  style='width: 100px;height:auto;object-fit: contain;'
                                )

                            v-card(v-if='form.imgCIRepreL' style="margin-right: 0px;margin-top: 10px;margin-bottom: 35px;")
                              v-card-title.justify-center
                                span C.I. DEL REPRESENTANTE LEGAL

                            a(v-if='form.imgCIRepreL' :href='ruta + form.imgCIRepreL' target='_blank' style='display:flex;justify-content:center;')
                                img(
                                  v-if='!verificarPdf(form.imgCIRepreL)'
                                  :src='ruta + form.imgCIRepreL'
                                  style='width: 100%;height:auto;object-fit: contain;'
                                )
                                img(
                                  v-if='verificarPdf(form.imgCIRepreL)'
                                  src='../assets/pdf.svg'
                                  style='width: 100px;height:auto;object-fit: contain;'
                                )

                            v-card(v-if='form.fachada' style="margin-right: 0px;margin-top: 10px;margin-bottom: 35px;")
                              v-card-title.justify-center
                                span FACHADA

                            a(v-if='form.fachada' :href='ruta + form.fachada' target='_blank' style='display:flex;justify-content:center;')
                                img(
                                  v-if='!verificarPdf(form.fachada)'
                                  :src='ruta + form.fachada'
                                  style='width: 100%;height:auto;object-fit: contain;'
                                )
                                img(
                                  v-if='verificarPdf(form.fachada)'
                                  src='../assets/pdf.svg'
                                  style='width: 100px;height:auto;object-fit: contain;'
                                )
                            div
                              v-flex(xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(v-if='form.estatus === "Pendiente"' style="background:green;border-radius:10px;", @click.native='save("Re")') Registrar
                                    v-btn(v-if='form.estatus === "Pendiente"' style="background:red;border-radius:10px;", @click.native='save("R")') Rechazar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-flex(xs12 style='margin-top: 5px;')
          v-layout(wrap)
            v-flex(xs6 style='padding-right: 80px;')
              v-text-field(v-model='search', label='Buscar')
            v-flex(xs6 style='padding-left: 80px;display: flex;align-items: center;')
              v-select(v-model='seleccionEst' :items='estat' label='Estatus')
              //- v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
              //-   template(v-slot:activator='{ on, attrs }')
              //-     v-text-field(v-model='dateFormatted' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' v-on='on')
              //-   v-date-picker(v-model='date' no-title='' dark='')
              //-     v-spacer
              //-     v-btn(text='' color='primary' @click='$refs.menu1.save(date)')
              //-       | OK
              v-btn.mx-0(icon, @click='buscar()', style='background: white;border-radius: 100%;margin-left:10px !important;').elevation-4
                v-icon(color='#ef8025' style='font-size: 1.70rem;') search
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
            v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                span.white--text Lista de solicitudes
        v-data-table.elevation-1(:headers='headers' :pagination.sync="pagination" :items="resultados" :search='search' style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td(v-if='props.item.fecha') {{ props.item.fecha | moment('DD/MM/YYYY') }}
            td(v-if='props.item.vendedor && props.item.vendedor.length > 0') {{ props.item.vendedor[0].ven_des }}
            td(v-else) Supervisor
            td(v-if='props.item.razon') {{ props.item.razon }}
            td(v-else) - -
            td(v-if='props.item.rif') {{ props.item.rif }}
            td(v-else) - -
            td(v-if='props.item.ciudad') {{ props.item.ciudad }}
            td(v-else) - -
            td(v-if='props.item.estado') {{ props.item.estado }}
            td(v-else) - -
            td(v-if='props.item.telefonoLocal') {{ props.item.telefonoLocal }}
            td(v-else) - -
            td(v-if='props.item.telefonoMovil') {{ props.item.telefonoMovil }}
            td(v-else) - -
            td(v-if='props.item.estatus') {{ props.item.estatus }}
            td(v-else) - -
            td.justify-start.layout.px-0
              v-tooltip(bottom v-if='mod')
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='editItem(props.item)' v-on="on" color='teal') visibility
                | Ver
              v-tooltip(bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='editItemPdf(props.item)' v-on="on" color='red') description
                | PDF
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import printJS from 'print-js'
import { serverImg } from "@/services/environment";
export default {
  name: "Solicitudes",
  data: (vm) => ({
    ruta: serverImg,
    search: "",
    modal: false,
    dialog6: false,
    dialog4: false,
    pagination: {
      sortBy: 'fecha', // The field that you're sorting by
      descending: true
    },
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    form: {
      co_ven: "",
      usuario: "",
      razon: "",
      rif: "",
      contribEsp: "",
      ciudad: "",
      estado: "",
      direccionFiscal: "",
      direccionEntrega: "",
      telefonoLocal: "",
      telefonoMovil: "",
      email: "",
      instagram: "",
      facebook: "",
      representCompania: [],
      referenciasComer: [],
      codigoFercove: "",
      asesorVenta: "",
      imgRegistroM: "",
      imgRifEmp: "",
      tipoLocal: "",
      sucursal: "",
      limiteCred: "",
      segmento: "",
      tipoCli: "",
      ven_des: '',
      co_zon: '',
      zona: '',
      puntoRef: '',
      personaCont: '',
      imgRifRepreL: "",
      imgCIRepreL: "",
      fachada: "",
      estatus: "",
      fecha: ""
    },
    dialog: false,
    resultados: [],
    estat: ["Pendiente", "Rechazado", "Registrado"],
    seleccionEst: "Pendiente",
    headers: [
      { text: "Fecha", value: "fecha" },
      { text: "Vendedor", value: "ven_des" },
      { text: "Razon Social", value: "razon" },
      { text: "Rif", value: "rif" },
      { text: "Ciudad", value: "ciudad" },
      { text: "Estado", value: "estado" },
      { text: "Teléfono local", value: "telefonoLocal" },
      { text: "Teléfono móvil", value: "telefonoMovil" },
      { text: "Estatus", value: "estatus" },
      { text: "Acción" }
    ],
    defaultForm: {
      co_ven: "",
      usuario: "",
      razon: "",
      rif: "",
      contribEsp: "",
      ciudad: "",
      estado: "",
      tipoLocal: "",
      sucursal: "",
      limiteCred: "",
      segmento: "",
      tipoCli: "",
      ven_des: '',
      co_zon: '',
      zona: '',
      puntoRef: '',
      personaCont: '',
      direccionFiscal: "",
      direccionEntrega: "",
      telefonoLocal: "",
      telefonoMovil: "",
      email: "",
      instagram: "",
      facebook: "",
      representCompania: [],
      referenciasComer: [],
      codigoFercove: "",
      asesorVenta: "",
      imgRegistroM: "",
      imgRifEmp: "",
      imgRifRepreL: "",
      imgCIRepreL: "",
      fachada: "",
      estatus: "",
      fecha: ""
    },
    cre: "",
    mod: "",
    elm: "",
    img: ""
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },
  watch: {
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
  },
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    close4() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog6 = false;
    },
    imprimirPdf2 () {
      printJS({
        printable: 'printJS-form2',
        type: 'html',
        targetStyles: ['*'],
        maxWidth: '100%',
        style: '@page { size: Letter portrait; }',
        css: 'printPdf'
      })
    },
    verificarPdf(item) {
      if (item.includes(".pdf")) {
        return true
      } else return false
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminmilo.permisos.length; i++) {
        if (this.$store.state.adminmilo.permisos[i].ruta === "Solicitudes") {
          for (
            let j = 0;
            j < this.$store.state.adminmilo.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminmilo.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminmilo.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminmilo.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    initialize() {
      Api.get("solicitudes/estatus?estatus=" +this.seleccionEst).then(res => {
        this.resultados = res.data;
      });
    },
    buscar() {
      this.dialog4 = true
      Api.get("solicitudes/estatus?estatus=" +this.seleccionEst).then(res => {
        this.resultados = res.data;
        this.dialog4 = false
      }).catch(err=>{
        this.dialog4 = false
        console.log(err)
      })
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
      this.initialize();
    },
    editItem(item) {
      this.editedIndex = this.resultados.indexOf(item);
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.dialog = true;
    },
    editItemPdf(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.dialog6 = true;
    },
    save(item) {
      let info = {
        _id: this.form._id,
        estatus: (item === "Re") ? "Registrado" : "Rechazado"
      }
      this.dialog4 = true
      Api.put("solicitudes", info)
        .then(() => {
          this.form = Object.assign({}, this.defaultForm);
          this.dialog = false;
          this.$swal.fire(
            "Felicidades.!",
            "Modificación realizada exitosamente.",
            "success"
          );
          this.dialog4 = false
          this.initialize();
        })
        .catch(err => {
          console.log(err);
          this.dialog4 = false
          this.$swal.fire(
            "Oops...",
            "Error encontrado, verifique los datos o llame al administrador.",
            "error"
          );
      });
    }
  }
};
</script>
<style lang="scss">
@media only screen and (max-width: 600px) {
  .wdd {
    width: 200px !important;
  }
}
.tablaD {
  display: flex;
  justify-content: space-between;
  border: 2px solid;
  border-top: 0px;
  padding: 10px;
}
.divFirma {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  align-items: flex-start;
}
.tablaI {
  display: flex;
  justify-content: space-between;
  padding-right: 40px;
}
.cll {
  .v-messages.theme--light {
    display: none !important;
  }
}
</style>
